import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import creationLogo from '../../DashboardTable/license--draft.svg'
import signatureLogo from '../../DashboardTable/pen.svg'
import activationLogo from '../../DashboardTable/power.svg'
import { formatContractDate } from '../formatContractDate'

interface DatesCellProps {
  dateCreatedAt: string
  dateSignature: string | null
  dateActivation: string | null
  createdBy: string | null
}

const DatesCell = ({ dateCreatedAt, dateSignature, dateActivation, createdBy }: DatesCellProps) => {
  const [css] = useStyletron()
  const { t } = useTranslation()
  const columnStyle = css({
    display: 'flex',
    flexDirection: 'column',
  })
  const rowStyle = css({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '.25rem',
  })
  const iconStyle = css({
    display: 'inline-block',
    height: '1rem',
    width: '1rem',
    marginRight: '.25rem',
  })
  const svgStyle = css({
    width: '100%',
  })

  return (
    <div className={columnStyle}>
      <div className={rowStyle}>
        <span className={iconStyle}>
          <img className={svgStyle} src={creationLogo} alt={t('contractsTable:creation')} />
        </span>
        {formatContractDate(dateCreatedAt, ' | ')} {createdBy ? `| ${createdBy}` : ''}
      </div>
      <div className={rowStyle}>
        <span className={iconStyle}>
          <img className={svgStyle} src={signatureLogo} alt={t('contractsTable:signature')} />
        </span>
        {formatContractDate(dateSignature, ' | ')}
      </div>
      <div className={rowStyle}>
        <span className={iconStyle}>
          <img className={svgStyle} src={activationLogo} alt={t('contractsTable:activation')} />
        </span>
        {formatContractDate(dateActivation, ' | ')}
      </div>
    </div>
  )
}

export default DatesCell
